import { render } from "./NewReleaseIcon.vue?vue&type=template&id=5bdc8e30"
import script from "./NewReleaseIcon.vue?vue&type=script&lang=js"
export * from "./NewReleaseIcon.vue?vue&type=script&lang=js"
script.render = render

export default script